import React, { useState } from "react";
import { X, Clock } from "lucide-react";

function toLocalIsoNow(offsetMins) {
  const d = new Date(Date.now() + offsetMins * 60000);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export default function ScheduleDialog({ open, onClose, onSubmit }) {
  const [when, setWhen] = useState(toLocalIsoNow(60));
  if (!open) return null;

  const submit = () => {
    const d = new Date(when);
    if (isNaN(d.getTime()) || d.getTime() < Date.now() - 60_000) {
      alert("Geçmiş bir tarih seçemezsin");
      return;
    }
    onSubmit(d.toISOString());
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" data-testid="schedule-dialog">
      <div className="bg-white border-hard shadow-hard-lg rounded-2xl p-6 w-full max-w-sm slide-up">
        <div className="flex items-center justify-between mb-3">
          <h2 className="font-display text-2xl flex items-center gap-2"><Clock strokeWidth={3} className="w-5 h-5" /> Zaman kapsülü</h2>
          <button onClick={onClose} data-testid="schedule-close-btn" className="w-9 h-9 border-hard-2 rounded-lg flex items-center justify-center press-btn">
            <X strokeWidth={3} className="w-4 h-4" />
          </button>
        </div>
        <p className="text-sm text-[#555] mb-3">Mesajın karşı tarafa ne zaman ulaşsın?</p>
        <input
          type="datetime-local"
          value={when}
          onChange={(e) => setWhen(e.target.value)}
          data-testid="schedule-datetime-input"
          className="w-full bg-[#F9F8F6] border-hard rounded-xl px-4 py-2.5 focus:outline-none focus:bg-white"
        />
        <div className="flex gap-2 mt-3 flex-wrap">
          {[
            [10, "10 dk"],
            [60, "1 sa"],
            [60 * 6, "6 sa"],
            [60 * 24, "Yarın"],
          ].map(([m, l]) => (
            <button
              key={m}
              onClick={() => setWhen(toLocalIsoNow(m))}
              data-testid={`schedule-quick-${m}`}
              className="border-hard-2 rounded-full px-3 py-1 text-xs font-black uppercase tracking-widest press-btn"
            >
              {l}
            </button>
          ))}
        </div>
        <button onClick={submit} data-testid="schedule-submit-btn" className="mt-4 w-full bg-[#D4B3FF] border-hard shadow-hard rounded-xl px-5 py-3 font-black press-btn">
          Zamanla
        </button>
      </div>
    </div>
  );
}
